// Navigation targets for confirmation-toast links ("was saved to your Likes",
// "was added to <playlist>"). One place that knows desktop = sidebars (mutually
// exclusive), mobile = Library sub-pages — so every toast lands the same way.
import { setLikesSidebarOpen } from '../redux/slices/likesSlice';
import { setSidebarOpen } from '../redux/slices/playlistSlice';
import { setLikedMixesSidebarOpen } from '../redux/slices/likedMixesSlice';
import { setFollowedArtistsSidebarOpen } from '../redux/slices/followedArtistsSlice';
import { setRekordboxSidebarOpen } from '../redux/slices/rekordboxSlice';
import { setSeratoSidebarOpen } from '../redux/slices/seratoSlice';
import { setTraktorSidebarOpen } from '../redux/slices/traktorSlice';
import { setVirtualDJSidebarOpen } from '../redux/slices/virtualdjSlice';
import { setActiveTab } from '../redux/slices/appSlice';
import { requestOpenPlaylist } from './playlistOpenRequest';
import { isNative } from './webOnly';

// Same breakpoint App.js uses for its mobile layout (isMobileWeb). Evaluated
// per call, not at module load, so a resized browser window picks the right
// destination.
export const isMobileLayout = () => isNative
    || (typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        && (window.matchMedia('(max-width: 768px)').matches || window.matchMedia('(max-height: 480px)').matches));

// Desktop sidebars are mutually exclusive (mirrors
// PlaylistSidebar.handleOpenLikesSidebar / handleOpenPlaylistSidebar).
const closeAllSidebars = (dispatch) => {
    dispatch(setSidebarOpen(false));
    dispatch(setLikesSidebarOpen(false));
    dispatch(setLikedMixesSidebarOpen(false));
    dispatch(setFollowedArtistsSidebarOpen(false));
    dispatch(setRekordboxSidebarOpen(false));
    dispatch(setSeratoSidebarOpen(false));
    dispatch(setTraktorSidebarOpen(false));
    dispatch(setVirtualDJSidebarOpen(false));
};

export function openLikes(dispatch) {
    if (isMobileLayout()) {
        dispatch(setActiveTab('likes'));
        return 'mobile';
    }
    closeAllSidebars(dispatch);
    dispatch(setLikesSidebarOpen(true));
    return 'desktop';
}

export function openFollowedArtists(dispatch) {
    if (isMobileLayout()) {
        dispatch(setActiveTab('followed-artists'));
        return 'mobile';
    }
    closeAllSidebars(dispatch);
    dispatch(setFollowedArtistsSidebarOpen(true));
    return 'desktop';
}

export function openPlaylist(dispatch, playlistId) {
    if (isMobileLayout()) {
        requestOpenPlaylist(playlistId); // sets the mount-restore memory first
        dispatch(setActiveTab('playlists'));
        return 'mobile';
    }
    closeAllSidebars(dispatch);
    dispatch(setSidebarOpen(true));
    requestOpenPlaylist(playlistId);
    return 'desktop';
}
